import { Modal, Button, Image, Form, Col } from 'react-bootstrap';
import './ConfirmationPopup.css'
import Loader from "../../../../../Shared/Loader/Loader";
import { MapPin, X } from 'lucide-react';
import React from 'react';
import ConfirmationIcon from '../../../../../../assets/images/Popup-Icons/PopupIcons_ConfirmationSucess.svg'
import { useSelector } from 'react-redux';
import TextBox from '../../Shared_FormControls/TextBox/TextBox';

const ConfirmationPopup = (props) => {
    const storeData = useSelector((store) => store.sharedReducer)

    return (
        <Modal className={`confirmation-popup default-popup modal-backdrop-bg-color pr-0`} show={props.showModal}
            onHide={props.onClose} backdrop={props.isStatic ? "static" : null} centered={props.centered}>
            <Modal.Header className='darkblue-bg-color' closeButton={props.isStatic ? false : true}>
                <Modal.Title>
                    <span className='popup-title-icon'><Image src={props.icon ? props.icon : ConfirmationIcon} /></span>
                    <span className='flex-grow-1'>{props.modalTitle ? props.modalTitle : 'Confirmation'}</span>
                    <span className='popup-close-icon'><X size={20} /></span>
                </Modal.Title>
            </Modal.Header>
            <Form noValidate
                validated={props?.validate}
                onSubmit={(event) => { event.preventDefault(); event.stopPropagation(); props.primaryAction(event) }}
            >
                <Modal.Body>
                    <Loader show={props.showPopupLoader || props.showLoader} styleType='absolute' />
                    {props.title}

                    {(storeData?.lenderSelectedSupplierDetails && storeData.lenderSelectedSupplierDetails._id && props.isRescindLoan) ?
                                <Form.Row>
                                <Form.Group as={Col} xs={12} className='mt-3'>
                                    <TextBox
                                        required
                                        label='Narrative'
                                        name='Narrative'
                                        onChange={(key, value) => props.twoWayBindRescindLoan(key, value)}
                                        value={props?.narrative}
                                        objectKey='narrative'
                                        placeholder=''
                                    />
                                </Form.Group>
                            </Form.Row> : null}
                            <Form.Row>
                                <Col className="text-xs-center d-flex justify-content-start modal-action-btns mt-3">
                                    <Button type="submit" variant="primary" className="default-btn">{props.primaryActionLabel ? props.primaryActionLabel : "Yes"}</Button>
                                    <Button type="button" variant="outline-secondary" className="default-btn" onClick={(event) => props.secondaryAction(event)}>{props.secondaryActionLabel ? props.secondaryActionLabel : "No"}</Button>
                                </Col>
                            </Form.Row>
                </Modal.Body>
            </Form>
        </Modal >
    )

}

export default ConfirmationPopup;